import { render } from "./AppLayoutNew.vue?vue&type=template&id=8b890a0e"
import script from "./AppLayoutNew.vue?vue&type=script&lang=js"
export * from "./AppLayoutNew.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "8b890a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b890a0e', script)) {
    api.reload('8b890a0e', script)
  }
  
  module.hot.accept("./AppLayoutNew.vue?vue&type=template&id=8b890a0e", () => {
    api.rerender('8b890a0e', render)
  })

}

script.__file = "resources/js/Layouts/AppLayoutNew.vue"

export default script